import React from 'react';
import { routerShape } from 'react-router';
import { connect } from 'react-redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { currentUserSelector } from '../../../selectors/AuthSelector';

class AuthenticatedRoute extends BcReactComponent {
  componentDidMount() {
    const { isAuthenticated, router } = this.props;
    if (!isAuthenticated) {
      window.location = `/user/login?destination=${encodeURIComponent(`${router.location.pathname}${router.location.search}`)}`;
    }
  }

  render() {
    return this.props.isAuthenticated ? this.props.children : null;
  }
}

AuthenticatedRoute.requiresAuthentication = true;

const mapStateToProps = (state) => ({
  isAuthenticated: !!currentUserSelector(state)
});

AuthenticatedRoute.propTypes = {
  children: React.PropTypes.oneOfType([
    React.PropTypes.arrayOf(React.PropTypes.node),
    React.PropTypes.node
  ]).isRequired,
  isAuthenticated: React.PropTypes.bool,
  router: routerShape
};

export default connect(mapStateToProps)(AuthenticatedRoute);



// WEBPACK FOOTER //
// ./app/components/shared/AuthenticatedRoute/AuthenticatedRoute.jsx